import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button } from '../components/common/Button';
import { ROUTES } from '../utils/constants';

export function NotFound() {
  const { tenant } = useParams<{ tenant: string }>();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-gray-300">404</h1>
        <h2 className="mt-4 text-2xl font-semibold text-gray-900">Page not found</h2>
        <p className="mt-2 text-gray-600">
          The page you're looking for doesn't exist or has been moved.
        </p>
        {tenant && (
          <div className="mt-6">
            <Link to={ROUTES.home(tenant)}>
              <Button>Go Home</Button>
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
